import { initContract } from '@ts-rest/core';

import { adminAppointmentContract } from './admin-appointment.contract';
import { adminFeatureFlagsContract } from './admin-feature-flags.contract';
import { adminLlmContract } from './admin-llm.contract';
import { adminOnCallContract } from './admin-on-call.contract';
import { adminPromptTemplateDefaultsContract } from './admin-prompt-template-defaults.contract';
import { adminTestEmailContract } from './admin-test-email.contract';
import { adminTranscriptContract } from './admin-transcript.contract';
import {
  appointmentOutputArtifactsContract,
  tenantAppointmentOutputArtifactsContract,
} from './appointment-output-artifacts.contract';
import { appointmentsContract } from './appointments.contract';
import { authContract } from './auth.contract';
import { avatarContract } from './avatar.contract';
import { carePlansContract } from './care-plans.contract';
import { chartsContract } from './charts.contract';
import { chatContract } from './chat.contract';
import { clinicalTasksContract } from './clinical-tasks.contract';
import { conversationStarterDefaultsContract } from './conversation-starter-defaults.contract';
import { differentialDiagnosesContract } from './differential-diagnoses.contract';
import { documentsContract } from './documents.contract';
import { evalContract } from './eval.contract';
import { experimentsContract } from './experiments.contract';
import { extensionOnboardingContract } from './extension-onboarding.contract';
import { gcsContract } from './gcs.contract';
import { humanOutputsContract } from './human-outputs.contract';
import { insightsPreviewContract } from './insights-preview.contract';
import { interstitialsContract } from './interstitials.contract';
import { llmOutputsContract } from './llm-outputs.contract';
import { llmContract } from './llm.contract';
import { locationsContract } from './locations.contract';
import { mastraContract } from './mastra.contract';
import { medicalCodesContract } from './medical-codes.contract';
import { medicineContract } from './medicine.contract';
import { medplumAdminContract, medplumContract } from './medplum.contract';
import { miniAppsContract } from './mini-apps.contract';
import { tenantAdminUsersContract } from './org/admin/tenant-admin-users.contract';
import { patientAgentInputsContract } from './patient-agent-inputs.contract';
import { patientImportContract } from './patient-import.contract';
import { patientsContract } from './patients.contract';
import { promptTemplateDefaultsContract } from './prompt-template-defaults.contract';
import { promptsContract } from './prompt.contract';
import { reportingContract } from './reporting.contract';
import { reviewerContract } from './reviewer.contract';
import { templateBundleDefaultsContract } from './template-bundle-defaults.contract';
import { tenantUserLifecycleContract } from './tenant-user-lifecycle.contract';
import { transcriptionContract } from './transcription.contract';
import { translationContract } from './translation.contract';
import { usersContract } from './users.contract';
import { waitlistContract } from './waitlist.contract';

const c = initContract();

export const apiContract = c.router(
  {
    appointments: appointmentsContract,
    appointmentOutputArtifacts: appointmentOutputArtifactsContract,
    tenantAppointmentOutputArtifacts: tenantAppointmentOutputArtifactsContract,
    insightsPreview: insightsPreviewContract,
    adminAppointment: adminAppointmentContract,
    adminOnCall: adminOnCallContract,
    adminFeatureFlags: adminFeatureFlagsContract,
    adminTestEmail: adminTestEmailContract,
    adminPromptTemplateDefaults: adminPromptTemplateDefaultsContract,
    auth: authContract,
    gcs: gcsContract,
    llm: llmContract,
    patientImport: patientImportContract,
    patients: patientsContract,
    waitlist: waitlistContract,
    prompts: promptsContract,
    eval: evalContract,
    charts: chartsContract,
    locations: locationsContract,
    humanOutputs: humanOutputsContract,
    llmOutputs: llmOutputsContract,
    transcription: transcriptionContract,
    adminLlm: adminLlmContract,
    translation: translationContract,
    medicine: medicineContract,
    reporting: reportingContract,
    reviewer: reviewerContract,
    avatar: avatarContract,
    medicalCodes: medicalCodesContract,
    users: usersContract,
    adminTranscript: adminTranscriptContract,
    chat: chatContract,
    conversationStarterDefaults: conversationStarterDefaultsContract,
    mastra: mastraContract,
    medplum: medplumContract,
    medplumAdmin: medplumAdminContract,
    carePlans: carePlansContract,
    differentialDiagnoses: differentialDiagnosesContract,
    patientAgentInputs: patientAgentInputsContract,
    miniApps: miniAppsContract,
    clinicalTasks: clinicalTasksContract,
    tenantAdminUsers: tenantAdminUsersContract,
    tenantUserLifecycle: tenantUserLifecycleContract,
    experiments: experimentsContract,
    extensionOnboarding: extensionOnboardingContract,
    interstitials: interstitialsContract,
    promptTemplateDefaults: promptTemplateDefaultsContract,
    templateBundleDefaults: templateBundleDefaultsContract,
    documents: documentsContract,
  },
  {
    pathPrefix: '/api',
  },
);
